import React, { useEffect } from 'react'
import Slides from '../slides/Slides'
import Footer from '../footer/Footer'

const Faq = ({M}) => {

   useEffect(() => {
      let elems = document.querySelectorAll(".collapsible");
      M.Collapsible.init(elems);
   }, []);

   return (
      <>
         <Slides M={M} tipoSlides="faq" />
         <div className="animated fadeIn">
            <div className="container section">
               <div className="row">
                  <div className="col s12 center">
                     <h6 className="grey-text text-darken-1">PREGUNTAS FRECUENTES</h6>
                     <h4 className="black-text text-darken-4">
                     <strong>¡Estamos para ayudarte!</strong>
                     </h4>
                  </div>
               </div>
               <div className="row">
                  <div className="col s12 m12 l6">
                     <ul className="collapsible">
                     <li>
                        <div className="collapsible-header">
                           <strong>
                           ¿Qué debo hacer en caso de accidente o enfermedad
                           profesional?
                           </strong>
                           <span className="badge">
                           <i className="material-icons light-blue-text">expand_more</i>
                           </span>
                        </div>
                        <div className="collapsible-body">
                           <p>
                           Debe informar el hecho ante su empleador, quien tiene la
                           obligación de comunicar el accidente o enfermedad a la
                           ART.
                           </p>
                        </div>
                     </li>
                     <li>
                        <div className="collapsible-header">
                           <strong>
                           Mi empleador no denunció mi accidente o enfermedad
                           profesional, ¿qué debo hacer?
                           </strong>
                           <span className="badge">
                           <i className="material-icons light-blue-text">expand_more</i>
                           </span>
                        </div>
                        <div className="collapsible-body">
                           <p>
                           Usted mismo puede efectuar la denuncia de su accidente o
                           enfermedad profesional ante la ART o los prestadores
                           médicos habilitados por la misma.
                           </p>
                           <p>
                           En la credencial de la ART, que su empleador tiene la
                           obligación de entregarle, figura una línea telefónica
                           gratuita para hacer la denuncia.
                           </p>
                           <p>
                           También puede hacerla de forma fehaciente a través de un
                           telegrama laboral (gratuito) o personalmente en la sede
                           más cercana de la ART.
                           </p>
                           <p>
                           Asimismo, puede concurrir directamente al prestador
                           médico de la ART para ser atendido y allí se efectuarán
                           los trámites administrativos correspondientes.
                           </p>
                        </div>
                     </li>
                     <li>
                        <div className="collapsible-header">
                           <strong>
                           En caso de que la ART no me reciba la denuncia, ¿qué debo
                           hacer?
                           </strong>
                           <span className="badge">
                           <i className="material-icons light-blue-text">expand_more</i>
                           </span>
                        </div>
                        <div className="collapsible-body">
                           <p>
                           La ART tiene la obligación de recibir toda denuncia de
                           accidente o enfermedad profesional. Si se negaran a
                           hacerlo, usted debe realizarla a través de una
                           notificación fehaciente, mediante el envío de telegrama
                           laboral (gratuito).
                           </p>
                        </div>
                     </li>
                     <li>
                        <div className="collapsible-header">
                           <strong>
                           ¿Qué debe hacer la ART a partir de la recepción de la
                           denuncia?
                           </strong>
                           <span className="badge">
                           <i className="material-icons light-blue-text">expand_more</i>
                           </span>
                        </div>
                        <div className="collapsible-body">
                           <p>
                           La ART debe tomar los recaudos necesarios para otorgar en
                           forma inmediata las prestaciones médicas y asistenciales.
                           </p>
                        </div>
                     </li>
                     <li>
                        <div className="collapsible-header">
                           <strong>
                           ¿Puede la ART rechazar un accidente o enfermedad
                           profesional?
                           </strong>
                           <span className="badge">
                           <i className="material-icons light-blue-text">expand_more</i>
                           </span>
                        </div>
                        <div className="collapsible-body">
                           <p>
                           A partir de la recepción de la denuncia, la ART tiene un
                           plazo de 10 días hábiles para rechazar el accidente o
                           enfermedad profesional, pudiendo extender este plazo por
                           otros 20 días corridos, siempre que le notifique que hará
                           uso de esos otros 20 días. Si durante ese tiempo la ART
                           no le notifica el rechazo, queda obligado a brindarle
                           todas las prestaciones de la Ley.
                           </p>
                        </div>
                     </li>
                     <li>
                        <div className="collapsible-header">
                           <strong>
                           ¿Qué puedo hacer si la ART me rechaza el accidente o
                           enfermedad profesional?
                           </strong>
                           <span className="badge">
                           <i className="material-icons light-blue-text">expand_more</i>
                           </span>
                        </div>
                        <div className="collapsible-body">
                           <p>
                           Si usted o su empleador han recibido alguna notificación
                           de la ART rechazando su accidente de trabajo o enfermedad
                           profesional, usted puede presentarse ante la Comisión
                           Médica de su zona para iniciar el Trámite por Rechazo de
                           la ART al accidente de trabajo o a la enfermedad
                           profesional.
                           </p>
                        </div>
                     </li>
                     <li>
                        <div className="collapsible-header">
                           <strong>
                           ¿Qué hago si la ART no responde una denuncia de AT/EP?
                           </strong>
                           <span className="badge">
                           <i className="material-icons light-blue-text">expand_more</i>
                           </span>
                        </div>
                        <div className="collapsible-body">
                           <p>
                           Si transcurridos 3 días de efectuada la denuncia la ART
                           no le otorga las prestaciones correspondientes se puede
                           iniciar un trámite ante la Comisión Médica por Silencio
                           de la ART.
                           </p>
                        </div>
                     </li>
                     <li>
                        <div className="collapsible-header">
                           <strong>
                           ¿En caso de AT/EP quién se debe ocupar de mi atención y
                           sueldo?
                           </strong>
                           <span className="badge">
                           <i className="material-icons light-blue-text">expand_more</i>
                           </span>
                        </div>
                        <div className="collapsible-body">
                           <p>
                           La ART, en forma inmediata, debe brindarle toda la
                           asistencia médica, farmacológica, prótesis, órtesis o
                           rehabilitación que sean necesarias, sin límites y en
                           forma totalmente gratuita. Además debe facilitarle el
                           traslado hacia y desde el prestador de la ART. El costo
                           del transporte público obligatoriamente debe ser cubierto
                           por la ART pero, en caso de necesitar otro tipo de
                           traslado, para que sea cubierto debe ser indicado por el
                           médico tratante.
                           </p>
                           <p>
                           Por otra parte, los pagos que usted debe recibir mientras
                           no pueda trabajar estarán a cargo de su empleador los
                           primeros 10 días (contados a partir del día siguiente a
                           la fecha del accidente o de la primera manifestación
                           invalidante) y a partir del décimo primer día los pagos
                           corren por cuenta de la ART. Dicho pago se realizará
                           hasta que se cumpla el año calendario desde la fecha que
                           se produjo accidente de trabajo o enfermedad profesional,
                           o hasta el alta médica, lo que ocurra primero. También es
                           posible que el empleador acuerde con la ART abonarle al
                           trabajador y que luego la ART se lo reintegre.
                           </p>
                        </div>
                     </li>
                     <li>
                        <div className="collapsible-header">
                           <strong>
                           La ART no me provee los medios de traslado hacia los
                           prestadores, ¿qué puedo hacer?
                           </strong>
                           <span className="badge">
                           <i className="material-icons light-blue-text">expand_more</i>
                           </span>
                        </div>
                        <div className="collapsible-body">
                           <p>
                           El medio de transporte utilizado para ir y volver del
                           prestador debe ser determinado por el médico tratante de
                           la ART. Éste deberá proveer el tipo de traslado indicado
                           (remis, ambulancia, etc.). En caso de no estar
                           especificado, corresponde el reintegro del gasto del
                           transporte público.
                           </p>
                        </div>
                     </li>
                     </ul>
                  </div>
                  <div className="col s12 m12 l6">
                     <ul className="collapsible">
                     <li>
                        <div className="collapsible-header">
                           <strong>
                           La ART no me reintegra el dinero de los viajes, ¿qué debo
                           hacer?
                           </strong>
                           <span className="badge">
                           <i className="material-icons light-blue-text">expand_more</i>
                           </span>
                        </div>
                        <div className="collapsible-body">
                           <p>
                           Usted debe presentar los comprobantes de gastos de
                           traslado en transporte público a la ART para que éste
                           cumpla con el reintegro. Si la ART no lo hace, puede
                           efectuar un reclamo ante la Superintendencia de Riesgos
                           del Trabajo al 0800-666-6778 de lunes a viernes en el
                           horario de 8 a 19 horas; personalmente o por correo
                           postal en Bartolomé Mitre 755 PB (C1036AAM) de la Ciudad
                           Autónoma de Buenos Aires, en el horario de 9 a 16 horas;
                           o a través de la página de internet www.srt.gob.ar.
                           </p>
                        </div>
                     </li>
                     <li>
                        <div className="collapsible-header">
                           <strong>
                           Si tengo que concurrir a la Comisión Médica o me envían a
                           realizar estudios, ¿quién paga los traslados?
                           </strong>
                           <span className="badge">
                           <i className="material-icons light-blue-text">expand_more</i>
                           </span>
                        </div>
                        <div className="collapsible-body">
                           <p>
                           La ART debe pagar los gastos de traslado ida y vuelta
                           para asegurar su presencia ante las Comisiones Médicas
                           jurisdiccionales, Comisión Médica Central, Justicia
                           Federal, Oficinas de Homologación y Visado, Organismos
                           laborales habilitados y también a los prestadores médicos
                           que efectúan los estudios complementarios, excepto si la
                           Aseguradora rechaza el accidente o enfermedad
                           profesional. Además, y si correspondiese, abonará el
                           alojamiento y alimentación durante el tiempo que el
                           trabajador deba estar a disposición de dichas entidades.
                           </p>
                           <p>
                           En caso de que la ART le hubiera rechazado el accidente o
                           la enfermedad profesional, no estará cubierto el
                           traslado, pero si la Comisión Médica dictamina a favor
                           del trabajador, la ART le reintegrará los gastos.
                           </p>
                        </div>
                     </li>
                     <li>
                        <div className="collapsible-header">
                           <strong>¿Hasta cuándo debe atenderme la ART?</strong>
                           <span className="badge">
                           <i className="material-icons light-blue-text">expand_more</i>
                           </span>
                        </div>
                        <div className="collapsible-body">
                           <p>
                           La ART le debe proporcionar la atención médica
                           asistencial mientras perdure la enfermedad laboral o las
                           consecuencias del accidente de trabajo, o sea hasta la
                           curación definitiva.
                           </p>
                        </div>
                     </li>
                     <li>
                        <div className="collapsible-header">
                           <strong>¿Cómo me notifico del alta médica?</strong>
                           <span className="badge">
                           <i className="material-icons light-blue-text">expand_more</i>
                           </span>
                        </div>
                        <div className="collapsible-body">
                           <p>
                           La ART debe notificarle a usted y a su empleador el alta
                           médica definitiva con la fecha de regreso al trabajo. Esa
                           comunicación deben hacerla por escrito.
                           </p>
                        </div>
                     </li>
                     <li>
                        <div className="collapsible-header">
                           <strong>
                           ¿Qué hago si estoy en desacuerdo con el tratamiento que
                           me brinda la ART o con el alta médica?
                           </strong>
                           <span className="badge">
                           <i className="material-icons light-blue-text">expand_more</i>
                           </span>
                        </div>
                        <div className="collapsible-body">
                           <p>
                           Si en su prestador médico hubiera presente un médico
                           auditor de la SRT, comuníquese con él. También puede
                           presentarse ante las Comisiones Médicas e iniciar un
                           Trámite por Divergencia en las Prestaciones o en el Alta
                           Médica.
                           </p>
                           <p>
                           En caso de estar imposibilitado para concurrir a trabajar
                           a pesar de tener el alta médica, informe al empleador la
                           situación y justifique con certificado médico los días de
                           ausencia al trabajo hasta que la Comisión Médica
                           dictamine por su caso.
                           </p>
                        </div>
                     </li>
                     <li>
                        <div className="collapsible-header">
                           <strong>
                           Una vez dado de alta, ¿qué debe hacer la ART si le quedó
                           alguna incapacidad?
                           </strong>
                           <span className="badge">
                           <i className="material-icons light-blue-text">expand_more</i>
                           </span>
                        </div>
                        <div className="collapsible-body">
                           <p>
                           La ART dispone de 15 días hábiles a partir del alta
                           médica para citarlo, fijar el porcentaje de incapacidad y
                           firmar un acuerdo con usted que luego presenta para
                           homologar ante la Oficina de Homologación y Visado de la
                           SRT (OHV). Una vez homologado, la ART o el EA debe
                           pagarle dentro de los 15 días hábiles a partir de la
                           notificación, la indemnización por la incapacidad
                           correspondiente (en caso de que sea menor o igual al
                           50%). Si no lo hace, puede presentar un reclamo en la
                           Superintendencia de Riesgos del Trabajo.-
                           </p>
                        </div>
                     </li>
                     <li>
                        <div className="collapsible-header">
                           <strong>
                           ¿Qué debo hacer si estoy dado de alta y la ART no me fija
                           el porcentaje de incapacidad?
                           </strong>
                           <span className="badge">
                           <i className="material-icons light-blue-text">expand_more</i>
                           </span>
                        </div>
                        <div className="collapsible-body">
                           <p>
                           La ART dispone de 15 días hábiles a partir del alta
                           médica para citarlo y fijar el porcentaje de incapacidad.
                           Pasado ese tiempo, puede iniciar un Trámite por
                           Divergencia en la Incapacidad Laboral Permanente o
                           Temporaria(ILP/ILT), según el caso, en la Comisión Médica
                           de su zona.
                           </p>
                        </div>
                     </li>
                     <li>
                        <div className="collapsible-header">
                           <strong>
                           ¿Qué debo hacer si no estoy de acuerdo con el porcentaje
                           de incapacidad fijado por la ART?
                           </strong>
                           <span className="badge">
                           <i className="material-icons light-blue-text">expand_more</i>
                           </span>
                        </div>
                        <div className="collapsible-body">
                           <p>
                           La ART dispone de 45 días hábiles a partir de que usted
                           exprese su disconformidad ante el alta médica para
                           presentar el caso en la Comisión Médica. Si pasado ese
                           tiempo la ART no lo presenta, puede iniciar un Trámite
                           por Divergencia en la Incapacidad Laboral Permanente
                           (ILP) en la Comisión Médica de su zona..
                           </p>
                        </div>
                     </li>
                     <li>
                        <div className="collapsible-header">
                           <strong>
                           Si tengo molestias posteriores al alta médica de la ART,
                           ¿qué puedo hacer?
                           </strong>
                           <span className="badge">
                           <i className="material-icons light-blue-text">expand_more</i>
                           </span>
                        </div>
                        <div className="collapsible-body">
                           <p>
                           Informe a su empleador que sigue con molestias para que
                           lo derive nuevamente a la ART y ésta lo cite. También
                           puede solicitar el reingreso a tratamiento directamente
                           en la ART mediante telegrama laboral (gratuito) o nota
                           con copia debidamente recibida. La ART debe citarlo y
                           definir la situación planteada. Si no lo cita, puede
                           presentar un reclamo ante la SRT llamando al
                           0800-666-6778 de lunes a viernes en el horario de 8 a 19
                           horas, personalmente y por correo postal en Bartolomé
                           Mitre 755 PB (C1036AAM) de la Ciudad Autónoma de Buenos
                           Aires, en el horario de 9 a 16 horas, o a través de la
                           página de internet www.srt.gob.ar.
                           </p>
                           <p>
                           En caso de ser citado por su ART y no estar de acuerdo
                           con lo resuelto, puede presentarse ante la Comisión
                           Médica de su zona para iniciar un Trámite por Divergencia
                           en las Prestaciones o en el Alta Médica.
                           </p>
                        </div>
                     </li>
                     <li>
                        <div className="collapsible-header">
                           <strong>
                           Si no puedo continuar con mis tareas habituales luego del
                           alta médica, ¿cuál es la obligación de la ART?
                           </strong>
                           <span className="badge">
                           <i className="material-icons light-blue-text">expand_more</i>
                           </span>
                        </div>
                        <div className="collapsible-body">
                           <p>
                           Si se consensuó reubicarlo laboralmente y necesita para
                           esa reubicación capacitarse, la ART proveerá la
                           capacitación. En caso de que la capacitación se
                           desarrolle dentro de la empresa, la ART realizará el
                           monitoreo de la misma. Producida su reubicación laboral,
                           la ART efectuará un seguimiento durante 60 días.
                           </p>
                           <p>
                           Si se evalúa que no puede reinsertarse a su puesto
                           habitual y no existe la posibilidad de reubicarlo
                           laboralmente, es obligación de la ART brindarle una
                           orientación laboral que incluye capacitación y/o
                           provisión de herramientas de trabajo. Esta orientación
                           laboral estará de acuerdo a sus posibilidades físicas, a
                           su nivel de instrucción y a su experiencia laboral
                           </p>
                        </div>
                     </li>
                     </ul>
                  </div>
               </div>
            </div>
         </div>
      </>
   );
}

export default Faq